/**
 * Global base CSS accessor. Single source of truth for the export + preview base
 * layer (CodeStitch reset, .cs-topper/.cs-title/.cs-text, .cs-button-solid
 * base+hover, dark-mode helpers) plus the logo/image/font runtime CSS wrappers.
 *
 * Replaces the three near-identical runtime loaders in exporter.js,
 * eleventy-exporter.js, and iframe-renderer.js — each of which fetched
 * data/global-base.css and silently fell back to an EMPTY base layer on any
 * failure (the root cause of a shipped site losing its entire CodeStitch base
 * layer). The bytes are now inlined at build time; there is no fetch, no catch,
 * and therefore no silent-loss failure class.
 *
 * getGlobalBaseCSS() is synchronous and memoized. The wrappers are idempotent
 * (marker-guarded), so applying them over the already-wrapped GLOBAL_BASE_CSS
 * bytes is a no-op that keeps output byte-identical to the old loaders while
 * staying robust if the frozen source ever changes shape.
 */

import { GLOBAL_BASE_CSS } from './global-base-css.js';
import { withCodeStitchBaselineCSS } from './codestitch-baseline-css.js';
import { withFontRuntimeCSS } from '../editing/font-runtime-css.js';
import { withImageRuntimeCSS } from '../editing/image-runtime-css.js';
import { withLogoRuntimeCSS } from '../editing/logo-normalizer.js';

let cachedGlobalBaseCSS = null;

export function getGlobalBaseCSS() {
  if (cachedGlobalBaseCSS !== null) return cachedGlobalBaseCSS;
  cachedGlobalBaseCSS = withCodeStitchBaselineCSS(
    withFontRuntimeCSS(withImageRuntimeCSS(withLogoRuntimeCSS(GLOBAL_BASE_CSS)))
  );
  return cachedGlobalBaseCSS;
}
